import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import Intro from "../../../../elements/blocks/intro";
import CustomFieldForm from "../../../../elements/custom-fields/custom-field-form";
export default function ActivityFieldNew() {
    const { t } = useTranslation();
    return (_jsxs(Fragment, { children: [_jsx(Intro, { name: t("fields.activity-fields.new-activity-field"), breadcrumbs: [
                    {
                        name: t("settings"),
                        link: "/settings",
                    },
                    {
                        name: t("fields.fields"),
                        link: "/settings/fields",
                    },
                    {
                        name: t("fields.activity-fields.activity-fields"),
                        link: "/settings/fields/activities",
                    },
                    {
                        name: t("fields.new-field"),
                        link: "/settings/fields/activities/new",
                    },
                ] }), _jsx(CustomFieldForm, { status: "new", type: "ticket_activities" })] }));
}
